export default __webpack_public_path__ + "static/media/work-dark.372b313a.svg";